import * as React from 'react';
import {
  List,
  DatagridConfigurable,
  TextField,
  EditButton,
  NumberInput,
  SelectColumnsButton,
  TopToolbar,
  FilterButton,
  CreateButton,
  DateInput, DateField,
  ImageField,
  TextInput,
} from "react-admin";
import CopyUrlField from '../field/CopyUrlField';

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const filters = [
    <NumberInput key={0} source="id" label="id" min={1} />,
    <TextInput key={1} source="code" label="code" />,
    <DateInput key={2} source="createdAt#$gte" label="Start Created At" />,
    <DateInput key={3} source="createdAt#$lte" label="End Created At" />,
];

export const GalleryList = () => {
  return (
    <List
      filters={filters}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
    >
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="code" />
        <ImageField source="file.path" label={'Image'} />
        <CopyUrlField
          source="file.path"
          baseUrl={process.env.REACT_APP_BASE_API_URL}
          label="Copy URL"
        />

        <DateField source="createdAt" showTime locales="lv-LV" />
        <EditButton />
      </DatagridConfigurable>
    </List>
  )
};
